import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import { useAppDispatch } from "../../../../../store";
import { reportAbuse } from "../../../../../acions/messages";

export const useSendReport = (
  conversationId: string,
  form: FormInstance,
  onClose: () => void,
) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onReport = useCallback(async () => {
    setIsLoading(true);

    try {
      const values: any = await form.validateFields();

      await Promise.resolve(dispatch(reportAbuse(conversationId, values)));

      onClose();
    } catch (e: any) {
      setIsLoading(false);
    }
  }, [conversationId, form, onClose, dispatch]);

  return { isLoading, onReport };
};
